import { useEffect, useReducer, Reducer } from 'react'

export const useReducerWithMiddleware = <State, Action>(
  reducer: Reducer<State, Action>,
  initialState: State,
  middlewareFn: (state: State) => void,
): [State, React.Dispatch<Action>] => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    middlewareFn(state)
  }, [state])

  return [state, dispatch]
}
